<!-- <p>upload-file-dialog works!</p> -->
<h2>Upload Files</h2>
<mat-dialog-content>
  <p>
    <i><b>Download the template file and fill the details</b></i>
  </p>
  <mat-divider></mat-divider>
  <div class="dialog-action-buttons">
    <button (click)="generateExcel()" mat-raised-button>Template File</button>
    <input
      type="file"
      #fileInput
      (change)="onFileChange($event)"
      accept=".xlsx"
      style="display: none"
    />
    <button mat-raised-button (click)="fileInput.click()">Upload File</button>
  </div>
  <mat-divider></mat-divider>
  <div class="dialog-file-view-error">
    <div
      style="
        width: 100%;
        text-align: center;
        border: 1px solid;
        border-radius: 5px;
        margin-bottom: 5px;
        font-weight: 500;
        letter-spacing: 3px;
        color: white;
        background-color: rgb(255, 0, 0, 0.5);
      "
      *ngIf="errorMessage"
    >
      {{ errorMessage }}
    </div>
    <div
      style="
        width: 100%;
        text-align: center;
        border: 1px solid;
        border-radius: 5px;
        margin-bottom: 5px;
        font-weight: 500;
        letter-spacing: 3px;
        color: white;
        background-color: rgb(0, 255, 0, 0.5);
      "
      *ngIf="successMessage"
    >
      {{ successMessage }}
    </div>
    <ul *ngIf="validationErrors.length">
      <li *ngFor="let error of validationErrors">{{ error }}</li>
    </ul>
    <div
      *ngIf="jsonTableData?.length > 0"
      class="ag-theme-alpine"
      style="height: 330px; width: 100%"
    >
      <ag-grid-angular
        style="height: 300px; width: 100%"
        [rowData]="jsonTableData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [editType]="'fullRow'"
        (cellValueChanged)="onCellValueChanged($event)"
        (rowValueChanged)="onRowValueChanged($event)"
      >
      </ag-grid-angular>
      <!-- <button mat-flat-button (click)="saveData()">Save Data</button> -->
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    [disabled]="jsonTableData?.length == 0"
    [mat-dialog-close]="jsonTableData"
    mat-flat-button
  >
    Save Data
  </button>
  <button mat-flat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
